import { InjectionToken } from '@angular/core';
import { Article, ClassificationAttribute } from '../../../model';
import { Occ } from '../../../occ';
import { Converter } from '../../../util/converter.service';

export const ARTICLE_NORMALIZER = new InjectionToken<Converter<Occ.Article, Article>>('ArticleNormalizer');

export const CLASSIFICATION_ATTRIBUTE_NORMALIZER = new InjectionToken<
  Converter<Occ.ClassificationAttribute, ClassificationAttribute>
>('ClassificationAttributeNormalizer');
